






import { Faction } from "@gaia-project/engine";
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { planetClass } from "../graphics/utils";

@Component
export default class PlayerToken extends Vue {
  @Prop()
  faction: Faction | "automa";

  get planetClass() {
    return planetClass(this.faction);
  }
}
